<script lang="ts">
  import { Input } from "sveltestrap";
  import { DisabledSelectMode, DisabledSelectModeMessage, Examplemultipleselect, ExamplemultipleselectMessage, LargeSelectMode, LargeSelectModeMessage, SingleSelect, SingleSelectMessage } from "../../../../utils/Constant/Constant";
  import Options from "./Options.svelte";
</script>
<tr>
    <td>{SingleSelect}</td>
    <td class="w-50">
        <Input type="select" name="select" id="exampleSelect" value="1">
            <Options />
        </Input>
    </td>
    <td><span>{SingleSelectMessage}</span></td>
  </tr>
  <tr>
    <td>{DisabledSelectMode}</td>
    <td>
        <Input type="select" name="select" id="exampleSelect" value="1" disabled>
            <Options />
        </Input>
    </td>
    <td><span>{@html DisabledSelectModeMessage}</span></td>
  </tr>
  <tr>
    <td>{LargeSelectMode}</td>
    <td>
        <Input type="select" class="form-control-lg mb-10" name="select" id="exampleSelect" value="1">
            <Options />
        </Input>
    </td>
    <td><span>{@html LargeSelectModeMessage}</span></td>
  </tr>
  <tr>
    <td>{Examplemultipleselect}</td>
    <td>
        <Input type="select" name="select" id="exampleSelect" value="1">
            <Options />
        </Input>
    </td>
    <td><span>{@html ExamplemultipleselectMessage}</span></td>
</tr>